import React, { useState, useRef, useEffect } from "react";

import ChevronDown from '../../../../autorizaciones/UI/ChevronDown';
import AlertCircle from '../../../../autorizaciones/UI/AlertCircle';
import CheckCircle from '../../../../autorizaciones/UI/CheckCircle';
import LetterX from '../../../../autorizaciones/UI/LetterX';
import AutoCompleteDiagnostico from '../../../../autorizaciones/UI/AutoCompleteDiagnostico';

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Typography,
} from "@material-ui/core";

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";

export const DiagnosticoFechaLaboratorio = ({diagnostico, setDiagnostico, 
  datosCompletos, setDatosCompletos, fechaPrescripcion, 
  setFechaPrescripcion, desdeHce = false}) => {
  const autoCompleteRef = useRef(null);

  const [autoCompleteValue] = useState(null);

  const changeDiagnosticoHandler = (value) => {
    setDiagnostico(value);
  };

  useEffect(() => {
    setDatosCompletos(!!diagnostico);
  }, [diagnostico]);

  return (
    <>
      <Grid item xs={9} style={{paddingRight: 25}}>
        <Accordion TransitionProps={{ unmountOnExit: true }}>
          <AccordionSummary expandIcon={<ChevronDown />}>
            <Typography variant="h6">
              Diagnóstico{datosCompletos ? <CheckCircle /> : <AlertCircle />}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid
              container
              spacing={3}
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "0.5rem",
              }}
            >
              {!diagnostico && (
                <Grid item xs={11}>
                  <AutoCompleteDiagnostico
                    ref={autoCompleteRef}
                    autoCompleteValue={autoCompleteValue}
                    label="Diagnóstico"
                    onChangeHandler={changeDiagnosticoHandler}
                  />
                </Grid>
              )}
              {!!diagnostico && (
                <Grid item xs={11}>
                  <Typography
                    style={{
                      color: "#68389F",
                      width: "-webkit-fill-available",
                      fontSize: "1rem",
                      fontWeight: "bold",
                      fontStyle: "italic",
                      postion: "relative",
                    }}
                  >
                    {diagnostico.problema}
                    <LetterX deleteFunction={() => {setDiagnostico(null)}} styles={{ position: "absolute", marginLeft: "0.5rem", cursor: "pointer" }}/>
                  </Typography>
                </Grid>
              )}
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
      <Grid item xs={3}>
        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
          <KeyboardDatePicker
            // fullWidth={true}
            margin="normal"
            format="dd/MM/yyyy"
            okLabel="Aceptar"
            clearLabel="Limpiar"
            cancelLabel="Cancelar"
            label="Fecha Prescripción"
            name="fechaPrescripcion"
            disabled={desdeHce}
            maxDate={new Date()} //maxDate
            value={
              moment(fechaPrescripcion).isValid()
                ? moment(fechaPrescripcion)
                : null
            }
            onChange={(date) => {
              setFechaPrescripcion(date);
            }}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
          />
        </MuiPickersUtilsProvider>        
      </Grid>
    </>    
  );
};
